declare var Sass: any;
declare var self: Window;
declare function importScripts(url: string): any;

//
// declare interface ISassFolder {
//     main?: IFileWithData;
//
//     [filename: string]: IFileWithData | undefined;
// }
//
// declare interface IFile {
//
// }
//
// declare interface IFileWithData extends IFile {
//     fileData?: IFileData
//     activeFileData?: IFileData
// }
//
// declare interface IFileData {
//     data: string;
// }


export default function () {
    if ('function' === typeof importScripts) {
        let baseURL = "https://remerge-se.web.app/";
        if (process.env.NODE_ENV !== 'production') {
            baseURL = "http://localhost:3000/";
        }
        const w = importScripts(baseURL + 'static/js/sass.js');
        const sass = new Sass(baseURL + 'static/js/sass.worker.js');
        self.addEventListener("message", e => {
            if (!e) return;
            const main = e.data["main.scss"];
            const data = e.data;
            if (data) {
                Object.keys(data).forEach((file: string) => {
                    if (file !== 'main.scss') {
                        const fileWithData = data[file]
                        if (fileWithData && fileWithData.activeFileData) {
                            sass.writeFile(`${file}`, fileWithData.activeFileData.data.replace(/\n/g, ""));
                        }
                    }
                })

            }
            if (main) {
                if (main && main.activeFileData) {
                    sass.compile(main.activeFileData.data, function callback(result: any) {
                        if (result.status === 0) {
                            postMessage({"css": result.text});
                        } else {
                            postMessage({"error": result.formatted});
                        }
                    })
                }
            } else {
                postMessage({"error": 'create main.sass to start.'});
            }
        });

    }
};
